import { Link } from 'react-router-dom';
import { siteInfo, quickLinks, categoryList, socialLinks } from '@/mocks/common';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl text-white"></i>
              </div>
              <span className="font-heading text-lg font-bold text-white">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mb-5">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 rounded-lg bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors"
                  title={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-white text-base font-semibold mb-5">快速链接</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-400 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-white text-base font-semibold mb-5">视频分类</h4>
            <ul className="space-y-3">
              {categoryList.map((cat) => (
                <li key={cat.label}>
                  <Link
                    to={cat.href}
                    className="text-sm text-foreground-400 hover:text-accent-400 transition-colors"
                  >
                    {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-white text-base font-semibold mb-5">联系我们</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-accent-400 mt-0.5"></i>
                <span className="text-sm text-foreground-400">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-accent-400 mt-0.5"></i>
                <span className="text-sm text-foreground-400">{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-accent-400 mt-0.5"></i>
                <span className="text-sm text-foreground-400">{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-sm text-foreground-500">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
            </p>
            <p className="text-sm text-foreground-500">
              {siteInfo.icp}
            </p>
          </div>
        </div>
      </div>

      <div className="overflow-hidden select-none pointer-events-none">
        <p className="font-heading text-[12vw] font-black text-foreground-800/15 leading-none whitespace-nowrap pb-6">
          {siteInfo.name}
        </p>
      </div>
    </footer>
  );
}